import { isEpisodeData, isMovieData, isPersonData, isSeasonData, isTvData } from '#helpers/dataTypeGuards.ts';
import { EpisodeDetails } from './Epsidode/index.tsx';
import { MovieDetails } from './Movie/index.tsx';
import { PersonDetails } from './Person/index.tsx';
import { SeasonDetails } from './Season/index.tsx';
import { TvDetails } from './Tv/index.tsx';
import { type ComponentProps } from './types.ts';

export const Component = ({ data, setActivePreview }: ComponentProps) => {
  if (!data) {
    return;
  }

  if (isMovieData(data)) {
    return <MovieDetails data={data.movie} setActivePreview={setActivePreview} />;
  }

  if (isPersonData(data)) {
    return <PersonDetails data={data.person} setActivePreview={setActivePreview} />;
  }

  if (isEpisodeData(data)) {
    return <EpisodeDetails data={data} setActivePreview={setActivePreview} />;
  }

  if (isSeasonData(data)) {
    return <SeasonDetails data={data} setActivePreview={setActivePreview} />;
  }

  if (isTvData(data)) {
    return <TvDetails data={data.tv} setActivePreview={setActivePreview} />;
  }

  return;
};
